import { Checkbox } from '@dextech-ai/dex-design-system';
import PropTypes from 'prop-types';

// DS Checkbox shown as a selector tile's state marker. The tile is the click
// target, so the box takes no pointer or keyboard input of its own.
const SelectorBoxCheckbox = ({ active = false, disabled = false, 'data-testid': dataTestId }) => (
	<span className="selector-box-2__checkbox" aria-hidden="true">
		<Checkbox
			checked={!!active}
			disabled={disabled}
			tabIndex={-1}
			data-testid={active ? dataTestId : undefined}
		/>
	</span>
);

SelectorBoxCheckbox.propTypes = {
	active: PropTypes.bool,
	disabled: PropTypes.bool,
	'data-testid': PropTypes.string,
};

export default SelectorBoxCheckbox;
